import { getFavicon, getLogo, getWebSettings } from "services/settingsService";
import { DataStoreConstructor } from "./core/DataStoreConstructor";
import { WebSettingsEntity } from "interfaces/adminSettings";
import { DocDto } from "interfaces";

export const THEME_ENUM = {
  DARK: "dark",
  LIGHT: "light",
} as const;

export const defaultWebSettings: WebSettingsEntity = {
  theme: THEME_ENUM.DARK,
  title: "",
  phoneNumbers: [""],
  email: "",
  copyrightText: "",
};

export class WebSettingsStore {
  logo = new DataStoreConstructor<DocDto | null>({
    fetchMethod: getLogo,
    defaultData: null,
  });

  favicon = new DataStoreConstructor<DocDto | null>({ 
    fetchMethod: getFavicon,
    defaultData: null,
  });

  settings = new DataStoreConstructor<WebSettingsEntity>({
    fetchMethod: getWebSettings,
    defaultData: defaultWebSettings,
  });

  fetch = async () => {
    return Promise.all([
      this.settings.fetch(), 
      this.logo.fetch(), 
      this.favicon.fetch()
    ]);
  };
}
